var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"but-wrapper"},[_c('vbutton',{staticClass:"but",attrs:{"text":_vm.$tr('interview.tests.all.questions.button.end'),"disabled":!_vm.canSave || _vm.loading,"loading":_vm.loading},on:{"click":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }